import Vue from 'vue'
import Vuex from 'vuex'
import groups from './modules/groupsStore'
import portfolio from './modules/portfolioStore'
import upload from './modules/uploadStore'
import users from './modules/usersStore'
import currencies from './modules/currenciesStore'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    groups,
    portfolio,
    upload,
    users,
    currencies,
  },
})



// WEBPACK FOOTER //
// ./src/-service-app/store/index.js